import { LanguageRequired } from '@/core';
import { Tag } from '@/features';

export const prepareTagToPost = ({
  name,
  showImmediately,
}: {
  name: LanguageRequired;
  showImmediately: boolean;
}): Tag => {
  return {
    name,
    is_active: showImmediately,
  };
};
